import React from 'react';
import { TemplateCategory, TemplateItem } from '../../types/mapEditor';

// Pre-defined templates
export const TEMPLATE_ITEMS: TemplateItem[] = [
  // Structures
  {
    id: 'building-small',
    name: 'Small Building',
    category: 'structures',
    icon: 'building',
    element: {
      type: 'rect',
      width: 80,
      height: 60,
      fill: 'rgba(100, 80, 60, 0.6)',
      stroke: '#8B7355',
      strokeWidth: 2,
    },
  },
  {
    id: 'building-large',
    name: 'Large Building',
    category: 'structures',
    icon: 'building-large',
    element: {
      type: 'rect',
      width: 800,
      height: 500,
      fill: 'rgba(100, 80, 60, 0.6)',
      stroke: '#8B7355',
      strokeWidth: 2,
    },
  },
  {
    id: 'room',
    name: 'Room',
    category: 'structures',
    icon: 'room',
    element: {
      type: 'rect',
      width: 60,
      height: 50,
      fill: 'rgba(80, 80, 90, 0.5)',
      stroke: '#666',
      strokeWidth: 1,
    },
  },
  {
    id: 'wall',
    name: 'Wall',
    category: 'structures',
    icon: 'wall',
    element: {
      type: 'rect',
      width: 100,
      height: 10,
      fill: '#555',
      stroke: '#777',
      strokeWidth: 1,
    },
  },
  {
    id: 'door',
    name: 'Door',
    category: 'structures',
    icon: 'door',
    element: {
      type: 'rect',
      width: 20,
      height: 8,
      fill: 'rgba(139, 90, 43, 0.8)',
      stroke: '#A0522D',
      strokeWidth: 1,
    },
  },
  {
    id: 'castle',
    name: 'Castle',
    category: 'structures',
    icon: 'castle',
    element: {
      type: 'rect',
      width: 120,
      height: 100,
      fill: 'rgba(245, 245, 245, 0.7)',
      stroke: '#DCDCDC',
      strokeWidth: 3,
    },
  },
  {
    id: 'tower',
    name: 'Tower',
    category: 'structures',
    icon: 'tower',
    element: {
      type: 'rect',
      width: 40,
      height: 80,
      fill: 'rgba(139, 90, 43, 0.7)',
      stroke: '#8B5A2B',
      strokeWidth: 2,
    },
  },

  // Barriers
  {
    id: 'fence',
    name: 'Fence',
    category: 'barriers',
    icon: 'fence',
    element: {
      type: 'line',
      points: [0, 0, 100, 0],
      stroke: '#8B4513',
      strokeWidth: 4,
    },
  },
  {
    id: 'barricade',
    name: 'Barricade',
    category: 'barriers',
    icon: 'barricade',
    element: {
      type: 'rect',
      width: 50,
      height: 20,
      fill: 'rgba(139, 69, 19, 0.7)',
      stroke: '#A0522D',
      strokeWidth: 2,
    },
  },
  {
    id: 'sandbags',
    name: 'Sandbags',
    category: 'barriers',
    icon: 'sandbags',
    element: {
      type: 'rect',
      width: 40,
      height: 15,
      fill: 'rgba(194, 178, 128, 0.8)',
      stroke: '#C2B280',
      strokeWidth: 2,
    },
  },
  {
    id: 'wire',
    name: 'Wire',
    category: 'barriers',
    icon: 'wire',
    element: {
      type: 'line',
      points: [0, 0, 80, 0],
      stroke: '#888',
      strokeWidth: 2,
    },
  },
  {
    id: 'road',
    name: 'Road',
    category: 'barriers',
    icon: 'road',
    element: {
      type: 'rect',
      width: 100,
      height: 40,
      fill: 'transparent',
      stroke: '#8B4513',
      strokeWidth: 3,
    },
  },
  {
    id: 'trail',
    name: 'Trail',
    category: 'barriers',
    icon: 'trail',
    element: {
      type: 'rect',
      width: 80,
      height: 20,
      fill: 'transparent',
      stroke: '#8B7355',
      strokeWidth: 2,
    },
  },
  {
    id: 'river',
    name: 'River',
    category: 'barriers',
    icon: 'river',
    element: {
      type: 'rect',
      width: 120,
      height: 30,
      fill: 'rgba(30, 144, 255, 0.5)',
      stroke: '#1E90FF',
      strokeWidth: 2,
    },
  },
  {
    id: 'lake',
    name: 'Lake',
    category: 'barriers',
    icon: 'lake',
    element: {
      type: 'circle',
      radius: 40,
      fill: 'rgba(30, 144, 255, 0.4)',
      stroke: '#1E90FF',
      strokeWidth: 2,
    },
  },
  {
    id: 'bridge',
    name: 'Bridge',
    category: 'barriers',
    icon: 'bridge',
    element: {
      type: 'rect',
      width: 60,
      height: 30,
      fill: 'rgba(139, 90, 43, 0.8)',
      stroke: '#8B5A2B',
      strokeWidth: 2,
    },
  },
  {
    id: 'trench',
    name: 'Trench',
    category: 'barriers',
    icon: 'trench',
    element: {
      type: 'rect',
      width: 100,
      height: 15,
      fill: 'rgba(101, 67, 33, 0.7)',
      stroke: '#654321',
      strokeWidth: 2,
    },
  },

  // Cover
  {
    id: 'tree',
    name: 'Tree',
    category: 'cover',
    icon: 'tree',
    element: {
      type: 'circle',
      radius: 20,
      fill: 'rgba(34, 139, 34, 0.6)',
      stroke: '#228B22',
      strokeWidth: 2,
    },
  },
  {
    id: 'bush',
    name: 'Bush',
    category: 'cover',
    icon: 'bush',
    element: {
      type: 'circle',
      radius: 15,
      fill: 'rgba(46, 139, 87, 0.5)',
      stroke: '#2E8B57',
      strokeWidth: 1,
    },
  },
  {
    id: 'crate',
    name: 'Crate',
    category: 'cover',
    icon: 'crate',
    element: {
      type: 'rect',
      width: 30,
      height: 30,
      fill: 'rgba(139, 90, 43, 0.7)',
      stroke: '#8B5A2B',
      strokeWidth: 2,
    },
  },
  {
    id: 'vehicle',
    name: 'Vehicle',
    category: 'cover',
    icon: 'vehicle',
    element: {
      type: 'rect',
      width: 60,
      height: 30,
      fill: 'rgba(70, 70, 70, 0.7)',
      stroke: '#555',
      strokeWidth: 2,
    },
  },
  {
    id: 'rock',
    name: 'Rock',
    category: 'cover',
    icon: 'rock',
    element: {
      type: 'circle',
      radius: 18,
      fill: 'rgba(105, 105, 105, 0.7)',
      stroke: '#696969',
      strokeWidth: 2,
    },
  },
  {
    id: 'tires',
    name: 'Tires',
    category: 'cover',
    icon: 'tires',
    element: {
      type: 'circle',
      radius: 15,
      fill: 'rgba(40, 40, 40, 0.8)',
      stroke: '#333',
      strokeWidth: 2,
    },
  },
  {
    id: 'barrel',
    name: 'Barrel',
    category: 'cover',
    icon: 'barrel',
    element: {
      type: 'circle',
      radius: 12,
      fill: 'rgba(100, 149, 237, 0.7)',
      stroke: '#4169E1',
      strokeWidth: 2,
    },
  },
  {
    id: 'ship',
    name: 'Ship',
    category: 'cover',
    icon: 'ship',
    element: {
      type: 'rect',
      width: 80,
      height: 30,
      fill: 'rgba(139, 90, 43, 0.7)',
      stroke: '#8B5A2B',
      strokeWidth: 2,
    },
  },
  {
    id: 'airplane',
    name: 'Airplane',
    category: 'cover',
    icon: 'airplane',
    element: {
      type: 'rect',
      width: 100,
      height: 80,
      fill: 'rgba(192, 192, 192, 0.5)',
      stroke: '#A9A9A9',
      strokeWidth: 2,
    },
  },
  {
    id: 'helicopter',
    name: 'Helicopter',
    category: 'cover',
    icon: 'helicopter',
    element: {
      type: 'rect',
      width: 70,
      height: 50,
      fill: 'rgba(60, 60, 60, 0.6)',
      stroke: '#444',
      strokeWidth: 2,
    },
  },
  {
    id: 'trailer',
    name: 'Trailer',
    category: 'cover',
    icon: 'trailer',
    element: {
      type: 'rect',
      width: 80,
      height: 35,
      fill: 'rgba(220, 220, 220, 0.7)',
      stroke: '#A9A9A9',
      strokeWidth: 2,
    },
  },

  // Zones
  {
    id: 'spawn-blue',
    name: 'Blue Spawn',
    category: 'zones',
    icon: 'spawn',
    element: {
      type: 'rect',
      width: 100,
      height: 80,
      fill: 'rgba(30, 144, 255, 0.3)',
      stroke: '#1E90FF',
      strokeWidth: 2,
    },
  },
  {
    id: 'spawn-red',
    name: 'Red Spawn',
    category: 'zones',
    icon: 'spawn',
    element: {
      type: 'rect',
      width: 100,
      height: 80,
      fill: 'rgba(220, 20, 60, 0.3)',
      stroke: '#DC143C',
      strokeWidth: 2,
    },
  },
  {
    id: 'spawn-yellow',
    name: 'Yellow Spawn',
    category: 'zones',
    icon: 'spawn',
    element: {
      type: 'rect',
      width: 100,
      height: 80,
      fill: 'rgba(255, 215, 0, 0.3)',
      stroke: '#FFD700',
      strokeWidth: 2,
    },
  },
  {
    id: 'objective-zone',
    name: 'Objective Zone',
    category: 'zones',
    icon: 'objective',
    element: {
      type: 'circle',
      radius: 40,
      fill: 'rgba(255, 215, 0, 0.3)',
      stroke: '#FFD700',
      strokeWidth: 2,
    },
  },
  {
    id: 'safe-zone',
    name: 'Safe Zone',
    category: 'zones',
    icon: 'safe',
    element: {
      type: 'rect',
      width: 80,
      height: 60,
      fill: 'rgba(50, 205, 50, 0.2)',
      stroke: '#32CD32',
      strokeWidth: 2,
      label: 'SAFE ZONE',
    },
  },
  {
    id: 'danger-zone',
    name: 'Danger Zone',
    category: 'zones',
    icon: 'danger',
    element: {
      type: 'rect',
      width: 80,
      height: 60,
      fill: 'rgba(255, 0, 0, 0.2)',
      stroke: '#FF0000',
      strokeWidth: 2,
      label: 'DANGER',
    },
  },

  // Markers
  {
    id: 'waypoint',
    name: 'Waypoint',
    category: 'markers',
    icon: 'waypoint',
    element: {
      type: 'circle',
      radius: 10,
      fill: 'rgba(255, 255, 255, 0.8)',
      stroke: '#fff',
      strokeWidth: 2,
    },
  },
  {
    id: 'objective-marker',
    name: 'Target',
    category: 'markers',
    icon: 'target',
    element: {
      type: 'circle',
      radius: 15,
      fill: 'rgba(255, 215, 0, 0.8)',
      stroke: '#FFD700',
      strokeWidth: 3,
    },
  },
  {
    id: 'flag-blue',
    name: 'Blue Flag',
    category: 'markers',
    icon: 'flag',
    element: {
      type: 'rect',
      width: 20,
      height: 30,
      fill: 'rgba(30, 144, 255, 0.9)',
      stroke: '#1E90FF',
      strokeWidth: 2,
    },
  },
  {
    id: 'flag-red',
    name: 'Red Flag',
    category: 'markers',
    icon: 'flag',
    element: {
      type: 'rect',
      width: 20,
      height: 30,
      fill: 'rgba(220, 20, 60, 0.9)',
      stroke: '#DC143C',
      strokeWidth: 2,
    },
  },
  {
    id: 'bomb',
    name: 'Bomb',
    category: 'markers',
    icon: 'bomb',
    element: {
      type: 'circle',
      radius: 12,
      fill: 'rgba(255, 69, 0, 0.9)',
      stroke: '#FF4500',
      strokeWidth: 2,
    },
  },
  {
    id: 'exit',
    name: 'Exit',
    category: 'markers',
    icon: 'exit',
    element: {
      type: 'rect',
      width: 60,
      height: 40,
      fill: 'rgba(76, 175, 80, 0.3)',
      stroke: '#4CAF50',
      strokeWidth: 3,
    },
  },
];

export const CATEGORY_NAMES: Record<TemplateCategory, string> = {
  structures: 'Structures',
  barriers: 'Barriers',
  cover: 'Cover',
  zones: 'Zones',
  markers: 'Markers',
};

// Icon components for templates
export const getTemplateIcon = (iconType: string): React.ReactElement => {
  switch (iconType) {
    case 'building':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#8B7355" strokeWidth="2">
          {/* Roof */}
          <polygon points="24,4 8,16 40,16" fill="rgba(139, 69, 19, 0.7)" stroke="#8B4513" />
          {/* Building body */}
          <rect x="8" y="16" width="32" height="28" fill="rgba(100, 80, 60, 0.6)" />
          {/* Windows */}
          <rect x="14" y="22" width="8" height="8" fill="#333" />
          <rect x="26" y="22" width="8" height="8" fill="#333" />
          <rect x="14" y="34" width="8" height="8" fill="#333" />
          <rect x="26" y="34" width="8" height="8" fill="#333" />
        </svg>
      );
    case 'building-large':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#8B7355" strokeWidth="2">
          {/* Roof */}
          <polygon points="24,2 4,14 44,14" fill="rgba(139, 69, 19, 0.7)" stroke="#8B4513" />
          {/* Building body */}
          <rect x="4" y="14" width="40" height="30" fill="rgba(100, 80, 60, 0.6)" />
          {/* Windows row 1 */}
          <rect x="8" y="18" width="6" height="6" fill="#333" />
          <rect x="17" y="18" width="6" height="6" fill="#333" />
          <rect x="26" y="18" width="6" height="6" fill="#333" />
          <rect x="35" y="18" width="6" height="6" fill="#333" />
          {/* Windows row 2 */}
          <rect x="8" y="28" width="6" height="6" fill="#333" />
          <rect x="17" y="28" width="6" height="6" fill="#333" />
          <rect x="26" y="28" width="6" height="6" fill="#333" />
          <rect x="35" y="28" width="6" height="6" fill="#333" />
          {/* Door */}
          <rect x="19" y="36" width="10" height="8" fill="#A0522D" />
        </svg>
      );
    case 'room':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#666" strokeWidth="2">
          <rect x="8" y="12" width="32" height="28" fill="rgba(80, 80, 90, 0.5)" />
        </svg>
      );
    case 'wall':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#777" strokeWidth="2">
          <rect x="4" y="20" width="40" height="8" fill="#555" />
        </svg>
      );
    case 'door':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#A0522D" strokeWidth="2">
          <rect x="16" y="12" width="16" height="28" fill="rgba(139, 90, 43, 0.8)" />
          <circle cx="28" cy="26" r="2" fill="#FFD700" />
        </svg>
      );
    case 'fence':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#8B4513" strokeWidth="2">
          <line x1="4" y1="24" x2="44" y2="24" strokeWidth="4" />
          <line x1="10" y1="16" x2="10" y2="32" />
          <line x1="24" y1="16" x2="24" y2="32" />
          <line x1="38" y1="16" x2="38" y2="32" />
        </svg>
      );
    case 'barricade':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#A0522D" strokeWidth="2">
          <rect x="8" y="18" width="32" height="12" fill="rgba(139, 69, 19, 0.7)" />
          <line x1="8" y1="18" x2="40" y2="30" />
          <line x1="8" y1="30" x2="40" y2="18" />
        </svg>
      );
    case 'sandbags':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#C2B280" strokeWidth="2">
          <ellipse cx="16" cy="28" rx="10" ry="6" fill="rgba(194, 178, 128, 0.8)" />
          <ellipse cx="32" cy="28" rx="10" ry="6" fill="rgba(194, 178, 128, 0.8)" />
          <ellipse cx="24" cy="20" rx="10" ry="6" fill="rgba(194, 178, 128, 0.8)" />
        </svg>
      );
    case 'wire':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#888" strokeWidth="2">
          <path d="M4 24 Q12 18, 20 24 Q28 30, 36 24 Q44 18, 44 24" />
        </svg>
      );
    case 'road':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#8B4513" strokeWidth="3">
          {/* Left and right borders only */}
          <line x1="4" y1="8" x2="4" y2="40" />
          <line x1="44" y1="8" x2="44" y2="40" />
          {/* Dashed line in the middle */}
          <line x1="24" y1="12" x2="24" y2="18" stroke="#8B4513" strokeWidth="2" strokeDasharray="4 4" />
          <line x1="24" y1="24" x2="24" y2="30" stroke="#8B4513" strokeWidth="2" strokeDasharray="4 4" />
          <line x1="24" y1="36" x2="24" y2="42" stroke="#8B4513" strokeWidth="2" strokeDasharray="4 4" />
        </svg>
      );
    case 'trail':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#8B7355" strokeWidth="2">
          {/* Winding trail path with dashed line */}
          <path d="M4 40 Q12 32, 16 36 T24 28 T32 32 T44 20" strokeDasharray="6 4" strokeLinecap="round" />
          {/* Small dots/stones along the trail */}
          <circle cx="8" cy="38" r="2" fill="#8B7355" />
          <circle cx="20" cy="32" r="1.5" fill="#8B7355" />
          <circle cx="28" cy="30" r="2" fill="#8B7355" />
          <circle cx="38" cy="24" r="1.5" fill="#8B7355" />
          {/* Grass/vegetation marks */}
          <path d="M10 35 L12 32 L14 35" stroke="#6B8E23" strokeWidth="1" fill="none" />
          <path d="M30 27 L32 24 L34 27" stroke="#6B8E23" strokeWidth="1" fill="none" />
        </svg>
      );
    case 'river':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#1E90FF" strokeWidth="2">
          <path d="M4 24 Q12 18, 20 24 Q28 30, 36 24 Q44 18, 48 24" fill="rgba(30, 144, 255, 0.5)" />
          <path d="M4 30 Q12 24, 20 30 Q28 36, 36 30 Q44 24, 48 30" fill="rgba(30, 144, 255, 0.3)" />
        </svg>
      );
    case 'lake':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#1E90FF" strokeWidth="2">
          <ellipse cx="24" cy="24" rx="18" ry="14" fill="rgba(30, 144, 255, 0.4)" />
          <ellipse cx="20" cy="22" rx="4" ry="2" fill="rgba(255, 255, 255, 0.3)" stroke="none" />
        </svg>
      );
    case 'bridge':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#8B5A2B" strokeWidth="2">
          <rect x="8" y="18" width="32" height="12" fill="rgba(139, 90, 43, 0.8)" />
          <line x1="12" y1="18" x2="12" y2="30" strokeWidth="3" />
          <line x1="24" y1="18" x2="24" y2="30" strokeWidth="3" />
          <line x1="36" y1="18" x2="36" y2="30" strokeWidth="3" />
          <rect x="4" y="30" width="8" height="8" fill="#654321" />
          <rect x="36" y="30" width="8" height="8" fill="#654321" />
        </svg>
      );
    case 'trench':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#654321" strokeWidth="2">
          {/* Outer walls */}
          <rect x="4" y="18" width="40" height="14" fill="none" />
          {/* Inner supports/braces */}
          <line x1="12" y1="18" x2="12" y2="32" />
          <line x1="24" y1="18" x2="24" y2="32" />
          <line x1="36" y1="18" x2="36" y2="32" />
        </svg>
      );
    case 'castle':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#DCDCDC" strokeWidth="2">
          <rect x="8" y="16" width="32" height="26" fill="rgba(245, 245, 245, 0.7)" />
          {/* Towers */}
          <rect x="6" y="8" width="8" height="12" fill="rgba(245, 245, 245, 0.7)" />
          <rect x="34" y="8" width="8" height="12" fill="rgba(245, 245, 245, 0.7)" />
          {/* Battlements */}
          <rect x="6" y="6" width="3" height="4" fill="rgba(245, 245, 245, 0.7)" />
          <rect x="11" y="6" width="3" height="4" fill="rgba(245, 245, 245, 0.7)" />
          <rect x="34" y="6" width="3" height="4" fill="rgba(245, 245, 245, 0.7)" />
          <rect x="39" y="6" width="3" height="4" fill="rgba(245, 245, 245, 0.7)" />
          {/* Gate */}
          <path d="M20 42 L20 32 Q24 28, 28 32 L28 42" fill="#654321" />
        </svg>
      );
    case 'tower':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#8B5A2B" strokeWidth="2">
          {/* Main tower body */}
          <rect x="16" y="14" width="16" height="30" fill="rgba(139, 90, 43, 0.7)" />
          {/* Observation platform */}
          <rect x="10" y="8" width="28" height="8" fill="rgba(139, 90, 43, 0.8)" />
          {/* Railings */}
          <line x1="10" y1="8" x2="10" y2="4" />
          <line x1="18" y1="8" x2="18" y2="4" />
          <line x1="30" y1="8" x2="30" y2="4" />
          <line x1="38" y1="8" x2="38" y2="4" />
          <line x1="10" y1="4" x2="38" y2="4" />
          {/* Ladder */}
          <line x1="24" y1="16" x2="24" y2="44" strokeWidth="1" />
          <line x1="22" y1="20" x2="26" y2="20" strokeWidth="1" />
          <line x1="22" y1="26" x2="26" y2="26" strokeWidth="1" />
          <line x1="22" y1="32" x2="26" y2="32" strokeWidth="1" />
          <line x1="22" y1="38" x2="26" y2="38" strokeWidth="1" />
          {/* Cross bracing */}
          <line x1="16" y1="44" x2="10" y2="44" />
          <line x1="32" y1="44" x2="38" y2="44" />
        </svg>
      );
    case 'helicopter':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#444" strokeWidth="2">
          {/* Main body */}
          <ellipse cx="24" cy="28" rx="12" ry="8" fill="rgba(60, 60, 60, 0.6)" />
          {/* Cockpit */}
          <ellipse cx="32" cy="28" rx="6" ry="6" fill="rgba(135, 206, 250, 0.5)" stroke="#87CEEB" />
          {/* Tail */}
          <rect x="4" y="26" width="10" height="4" fill="rgba(60, 60, 60, 0.6)" />
          <rect x="2" y="22" width="4" height="8" fill="rgba(60, 60, 60, 0.6)" />
          {/* Main rotor */}
          <line x1="8" y1="18" x2="40" y2="18" strokeWidth="2" />
          <ellipse cx="24" cy="18" rx="3" ry="2" fill="#333" />
          {/* Skids */}
          <line x1="16" y1="36" x2="32" y2="36" />
          <line x1="18" y1="34" x2="18" y2="36" />
          <line x1="30" y1="34" x2="30" y2="36" />
        </svg>
      );
    case 'trailer':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#A9A9A9" strokeWidth="2">
          {/* Main body */}
          <rect x="4" y="16" width="36" height="18" rx="2" fill="rgba(220, 220, 220, 0.7)" />
          {/* Front rounded part */}
          <path d="M40 16 Q46 16, 46 22 L46 28 Q46 34, 40 34" fill="rgba(220, 220, 220, 0.7)" />
          {/* Windows */}
          <rect x="8" y="20" width="6" height="6" fill="rgba(135, 206, 250, 0.6)" stroke="#87CEEB" strokeWidth="1" />
          <rect x="18" y="20" width="6" height="6" fill="rgba(135, 206, 250, 0.6)" stroke="#87CEEB" strokeWidth="1" />
          <rect x="28" y="20" width="6" height="6" fill="rgba(135, 206, 250, 0.6)" stroke="#87CEEB" strokeWidth="1" />
          {/* Door */}
          <rect x="10" y="28" width="8" height="6" fill="#888" strokeWidth="1" />
          {/* Wheels */}
          <circle cx="12" cy="38" r="4" fill="#333" stroke="#333" />
          <circle cx="32" cy="38" r="4" fill="#333" stroke="#333" />
          {/* Hitch */}
          <line x1="0" y1="26" x2="4" y2="26" strokeWidth="3" />
          <circle cx="0" cy="26" r="2" fill="#555" />
        </svg>
      );
    case 'exit':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#4CAF50" strokeWidth="2">
          <rect x="4" y="10" width="40" height="28" rx="4" fill="rgba(76, 175, 80, 0.3)" />
          <text x="24" y="29" textAnchor="middle" fill="#4CAF50" fontSize="12" fontWeight="bold">EXIT</text>
        </svg>
      );
    case 'tree':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#228B22" strokeWidth="2">
          <circle cx="24" cy="20" r="14" fill="rgba(34, 139, 34, 0.6)" />
          <rect x="21" y="32" width="6" height="10" fill="#8B4513" stroke="#8B4513" />
        </svg>
      );
    case 'bush':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#2E8B57" strokeWidth="2">
          <circle cx="18" cy="28" r="10" fill="rgba(46, 139, 87, 0.5)" />
          <circle cx="30" cy="28" r="10" fill="rgba(46, 139, 87, 0.5)" />
          <circle cx="24" cy="20" r="10" fill="rgba(46, 139, 87, 0.5)" />
        </svg>
      );
    case 'crate':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#8B5A2B" strokeWidth="2">
          <rect x="10" y="14" width="28" height="24" fill="rgba(139, 90, 43, 0.7)" />
          <line x1="10" y1="26" x2="38" y2="26" />
          <line x1="24" y1="14" x2="24" y2="38" />
        </svg>
      );
    case 'vehicle':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#555" strokeWidth="2">
          <rect x="6" y="18" width="36" height="16" rx="2" fill="rgba(70, 70, 70, 0.7)" />
          <circle cx="14" cy="34" r="4" fill="#333" />
          <circle cx="34" cy="34" r="4" fill="#333" />
          <rect x="8" y="12" width="20" height="8" rx="2" fill="rgba(70, 70, 70, 0.7)" />
        </svg>
      );
    case 'rock':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#696969" strokeWidth="2">
          <ellipse cx="24" cy="28" rx="16" ry="12" fill="rgba(105, 105, 105, 0.7)" />
        </svg>
      );
    case 'tires':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#333" strokeWidth="2">
          <circle cx="16" cy="28" r="10" fill="rgba(40, 40, 40, 0.8)" />
          <circle cx="16" cy="28" r="4" fill="#1a1a1a" />
          <circle cx="32" cy="28" r="10" fill="rgba(40, 40, 40, 0.8)" />
          <circle cx="32" cy="28" r="4" fill="#1a1a1a" />
          <circle cx="24" cy="18" r="8" fill="rgba(40, 40, 40, 0.8)" />
          <circle cx="24" cy="18" r="3" fill="#1a1a1a" />
        </svg>
      );
    case 'barrel':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#4169E1" strokeWidth="2">
          <ellipse cx="24" cy="12" rx="12" ry="4" fill="rgba(100, 149, 237, 0.7)" />
          <ellipse cx="24" cy="36" rx="12" ry="4" fill="rgba(100, 149, 237, 0.7)" />
          <path d="M12 12 L12 36" />
          <path d="M36 12 L36 36" />
          <ellipse cx="24" cy="24" rx="12" ry="3" fill="none" />
        </svg>
      );
    case 'ship':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#8B4513" strokeWidth="2">
          {/* Hull - корпус \__/ */}
          <path d="M4 24 L8 36 L40 36 L44 24 Z" fill="rgba(139, 90, 43, 0.8)" strokeWidth="3" />
          {/* Deck */}
          <line x1="6" y1="24" x2="42" y2="24" stroke="#A0522D" />
          {/* Mast */}
          <line x1="24" y1="4" x2="24" y2="24" strokeWidth="3" />
          {/* Sail */}
          <polygon points="24,5 38,14 24,22" fill="rgba(255, 255, 255, 0.9)" stroke="#ddd" />
          {/* Flag */}
          <polygon points="24,4 29,6 24,8" fill="rgba(220, 20, 60, 0.9)" stroke="#DC143C" strokeWidth="1" />
        </svg>
      );
    case 'airplane':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#A9A9A9" strokeWidth="2">
          {/* Fuselage */}
          <ellipse cx="24" cy="24" rx="4" ry="18" fill="rgba(192, 192, 192, 0.6)" />
          {/* Nose */}
          <ellipse cx="24" cy="8" rx="3" ry="4" fill="rgba(192, 192, 192, 0.6)" />
          {/* Wings */}
          <polygon points="24,20 4,28 4,26 24,22" fill="rgba(192, 192, 192, 0.6)" />
          <polygon points="24,20 44,28 44,26 24,22" fill="rgba(192, 192, 192, 0.6)" />
          {/* Tail wings */}
          <polygon points="24,38 14,44 14,42 24,40" fill="rgba(192, 192, 192, 0.6)" />
          <polygon points="24,38 34,44 34,42 24,40" fill="rgba(192, 192, 192, 0.6)" />
          {/* Tail fin */}
          <polygon points="24,36 24,44 22,44 20,40 24,36" fill="rgba(192, 192, 192, 0.6)" />
          {/* Windows */}
          <ellipse cx="24" cy="12" rx="2" ry="1.5" fill="rgba(135, 206, 250, 0.7)" stroke="#87CEEB" strokeWidth="1" />
        </svg>
      );
    case 'spawn':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="8" y="12" width="32" height="26" rx="2" strokeDasharray="4 2" />
          <circle cx="24" cy="25" r="6" />
          <path d="M24 15 L24 19 M24 31 L24 35 M15 25 L19 25 M29 25 L33 25" />
        </svg>
      );
    case 'objective':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#FFD700" strokeWidth="2">
          <circle cx="24" cy="24" r="16" strokeDasharray="4 2" fill="rgba(255, 215, 0, 0.3)" />
          <circle cx="24" cy="24" r="8" />
          <circle cx="24" cy="24" r="3" fill="#FFD700" />
        </svg>
      );
    case 'safe':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#32CD32" strokeWidth="2">
          <rect x="4" y="8" width="40" height="32" rx="2" fill="rgba(50, 205, 50, 0.2)" />
          <path d="M16 18 L21 23 L32 12" strokeWidth="3" />
          <text x="24" y="34" textAnchor="middle" fill="#32CD32" fontSize="7" fontWeight="bold" stroke="none">SAFE</text>
        </svg>
      );
    case 'danger':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#FF0000" strokeWidth="2">
          <rect x="4" y="8" width="40" height="32" rx="2" fill="rgba(255, 0, 0, 0.2)" />
          <path d="M24 12 L24 22 M24 26 L24 28" strokeWidth="3" />
          <text x="24" y="34" textAnchor="middle" fill="#FF0000" fontSize="6" fontWeight="bold" stroke="none">DANGER</text>
        </svg>
      );
    case 'waypoint':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#fff" strokeWidth="2">
          <circle cx="24" cy="24" r="8" fill="rgba(255, 255, 255, 0.8)" />
          <circle cx="24" cy="24" r="3" fill="#333" />
        </svg>
      );
    case 'target':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#FFD700" strokeWidth="2">
          <circle cx="24" cy="24" r="14" />
          <circle cx="24" cy="24" r="8" />
          <circle cx="24" cy="24" r="3" fill="#FFD700" />
        </svg>
      );
    case 'flag':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="16" y1="40" x2="16" y2="10" strokeWidth="3" />
          <polygon points="18,10 36,18 18,26" fill="currentColor" />
        </svg>
      );
    case 'bomb':
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#FF4500" strokeWidth="2">
          <circle cx="24" cy="28" r="12" fill="rgba(255, 69, 0, 0.9)" />
          <path d="M24 16 L24 8 M20 10 L24 8 L28 10" />
        </svg>
      );
    default:
      return (
        <svg viewBox="0 0 48 48" fill="none" stroke="#888" strokeWidth="2">
          <rect x="8" y="8" width="32" height="32" rx="4" />
        </svg>
      );
  }
};
